import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableTheme } from '../../helpers/tableTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Datetime from "react-datetime";
// import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
// import moment from "moment-timezone";
import dayjs from 'dayjs';
import toast from 'react-hot-toast';
import Datetime from 'react-datetime';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import { Form, InputGroup } from '@themesberg/react-bootstrap';
import { clearBatchByDate, getBatchByDate } from '../../redux/actions/batch';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import CustomErrorView from '../../components/CustomErrorView';
import ColorComponent from '../../components/ColorComponent';

const columns = [
  {
    name: 'Batch Id',
    label: 'Batch Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Collector Name',
    label: 'Collector Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Collector Contact Number',
    label: 'Collector Contact Number',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Date',
    label: 'Date',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'Status',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  {
    name: 'Total Transactions',
    label: 'Total Transactions',
    options: {
      filter: false,
      sort: true,
    },
  },
];

function TransactionViewBatch({ history, match }) {
  const dispatch = useDispatch();
  // const collectorData = useSelector((state) => state.collector.collectorData);
  const [batchDate, setBatchDate] = useState('');
  const [showErrPage, setShowErrPage] = useState(false);

  const batchData = useSelector((state) => state.batch.batchData);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format('YYYY-MM-DD')
  );

  // useEffect(() => {
  //   if (history.location.pathname === '/transactions/batches/today') {
  //     setIsLoading(true);
  //     dispatch(getBatchByDate('', true)).then(() => {
  //       setIsLoading(false);
  //     });
  //   } else {
  //     const someDate = match.params?.date;
  //     if (!someDate) {
  //       setShowErrPage(true);
  //     } else {
  //       setBatchDate(someDate);
  //       setIsLoading(true);
  //       dispatch(getBatchByDate(someDate)).then(() => {
  //         setIsLoading(false);
  //       });
  //     }
  //   }
  //   return () => {
  //     dispatch(clearBatchByDate());
  //   };
  // }, []);

  useEffect(() => {
    if (selectedDate !== '') {
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
      setIsLoading(true);
      dispatch(getBatchByDate(formattedDate)).then(() => {
        setIsLoading(false);
      });
    }
    return () => {
      dispatch(clearBatchByDate());
    };
  }, [selectedDate]);

  const onRowsSelect = (rowData, rowMeta) => {
    if (rowData[0] === 'N/A') {
      toast.error(`${rowData[1]} hasn't submitted transactions.`);
    } else {
      history.push(`/transactions/batch/${rowData[0]}`);
    }
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    // serverSide: true,
    // viewColumns: false,
    search: true,
    filter: true,
    download: false,
    elevation:0,
    customToolbar: () => (
      <Datetime
        timeFormat={false}
        name='selectedDate'
        value={selectedDate}
        onChange={setSelectedDate}
        closeOnSelect
        renderInput={(props, openCalendar) => {
          return (
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faCalendarAlt} />
              </InputGroup.Text>
              <Form.Control
                {...props}
                required
                type='text'
                placeholder='Select Date'
                onFocus={openCalendar}
                value={
                  selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : ''
                }
              />
            </InputGroup>
          );
        }}
      />
    ),
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <>
        <div>
          <MuiThemeProvider theme={tableTheme}>
            {isLoading ? (
              <CustomDashboardLoader />
            ) : (
              <MUIDataTable
                title={`Batches`}
                data={batchData}
                columns={columns}
                options={options}
              />
            )}
          </MuiThemeProvider>
        </div>
      </>
    );
  }
}

export default TransactionViewBatch;
